import { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import Table from "common/Table";
import ProcesosApi from "api/procesosApi";

function CardOperador() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDatosOperador = async () => {
      try {
        const respOperador = await ProcesosApi.obtenerEstadisticas("OPERADOR");
        const data = respOperador.data;

        console.log("Datos recibidos:", data);

        const nuevasFilas = data.map((item, index) => {
          // Función para obtener color del estado
          const getEstadoColor = (estado) => {
            switch (estado) {
              case "BORRADOR":
                return "#9e9e9e";
              case "PENDIENTE":
                return "#ff9800";
              case "EN PROCESO":
                return "#2196f3";
              case "EN CURSO":
                return "#4caf50";
              case "EXITOSO":
                return "#4caf50";
              case "FALLIDO":
                return "#f44336";
              case "RECHAZADO":
                return "#f44336";
              case "SUSPENDIDO":
                return "#ff5722";
              case "ARCHIVADO":
                return "#607d8b";
              default:
                return "#9e9e9e";
            }
          };

          // Función para obtener color de los días restantes
          const getDiasColor = (dias) => {
            if (dias === null) return "#9e9e9e";
            if (dias <= 5) return "#f44336";
            if (dias <= 15) return "#ff9800";
            return "#4caf50";
          };

          return {
            id: `${item.proceso}-${index}`,
            key: `${item.proceso}-${index}`,
            proceso: (
              <SuiBox minWidth="250px">
                <SuiTypography variant="button" fontWeight="bold" textColor="dark">
                  {item.proceso}
                </SuiTypography>
                <SuiTypography variant="caption" textColor="text" display="block">
                  Deudor: <strong>{item.cliente}</strong>
                </SuiTypography>
                <SuiTypography variant="caption" textColor="secondary" display="block">
                  Creado: <strong>{item.fecha_creacion}</strong>
                </SuiTypography>
              </SuiBox>
            ),
            estado: (
              <Box display="flex" justifyContent="center" minWidth="120px">
                <Chip
                  label={item.estado}
                  size="small"
                  style={{
                    backgroundColor: getEstadoColor(item.estado),
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "11px",
                    minWidth: "100px",
                  }}
                />
              </Box>
            ),
            responsable: (
              <SuiBox minWidth="200px">
                <SuiTypography variant="caption" textColor="text" fontWeight="medium">
                  {item.responsable || "Sin asignar"}
                </SuiTypography>
                <SuiTypography variant="caption" textColor="secondary" display="block">
                  Etapa: {item.etapa}
                </SuiTypography>
              </SuiBox>
            ),
            admision: (
              <SuiBox textAlign="center" minWidth="180px">
                {item.admitido && item.fecha_admision ? (
                  <SuiBox>
                    <SuiTypography
                      variant="caption"
                      textColor="text"
                      display="block"
                      fontWeight="medium"
                    >
                      Admitido: {item.fecha_admision}
                    </SuiTypography>
                    {item.dias_restantes !== null && (
                      <Box mt={0.5}>
                        <Chip
                          label={`${item.dias_restantes} días restantes`}
                          size="small"
                          style={{
                            backgroundColor: getDiasColor(item.dias_restantes),
                            color: "white",
                            fontWeight: "bold",
                            fontSize: "10px",
                          }}
                        />
                      </Box>
                    )}
                  </SuiBox>
                ) : (
                  <SuiBox>
                    <Chip
                      label="No admitido"
                      size="small"
                      style={{
                        backgroundColor: "#9e9e9e",
                        color: "white",
                        fontWeight: "bold",
                        fontSize: "11px",
                      }}
                    />
                  </SuiBox>
                )}
              </SuiBox>
            ),
          };
        });

        setRows(nuevasFilas);
        setLoading(false);
      } catch (error) {
        console.error("Error al obtener los datos del backend:", error);
        setLoading(false);
      }
    };

    fetchDatosOperador();
  }, []);

  const columns = [
    { name: "proceso", align: "left" },
    { name: "estado", align: "center" },
    { name: "responsable", align: "left" },
    { name: "admision", align: "center" },
  ];

  if (loading) {
    return (
      <Card style={{ width: "100%" }}>
        <SuiBox p={3} textAlign="center">
          <SuiTypography variant="body2" textColor="text">
            Cargando procesos...
          </SuiTypography>
        </SuiBox>
      </Card>
    );
  }

  return (
    <div style={{ width: "100%" }}>
      {/* Estilos CSS para la tabla */}
      <style>
        {`
          .compact-table table {
            border-collapse: collapse !important;
          }
          
          .compact-table tbody tr {
            border-bottom: 1px solid #e0e0e0 !important;
          }
          
          .compact-table tbody tr:hover {
            background-color: #f5f5f5 !important;
          }
          
          .compact-table tbody tr:last-child {
            border-bottom: none !important;
          }
          
          .compact-table td {
            padding: 8px 12px !important;
            vertical-align: middle !important;
          }
          
          .compact-table th {
            padding: 12px !important;
            border-bottom: 2px solid #e0e0e0 !important;
          }
        `}
      </style>

      <Card style={{ width: "100%" }}>
        <SuiBox display="flex" justifyContent="space-between" alignItems="center" p={2}>
          <SuiBox>
            <SuiTypography variant="h6" gutterBottom>
              Mis Procesos Asignados
            </SuiTypography>
          </SuiBox>
          <SuiBox>
            <SuiBox display="flex" alignItems="center" lineHeight={0}>
              <Icon className="font-bold text-info">assignment</Icon>
              <SuiTypography variant="button" fontWeight="regular" textColor="text">
                &nbsp;
                <strong>
                  {rows.length === 0
                    ? "Sin procesos"
                    : rows.length === 1
                    ? "1 proceso asignado"
                    : `${rows.length} procesos asignados`}
                </strong>
              </SuiTypography>
            </SuiBox>
          </SuiBox>
          <SuiBox>
            <Icon
              style={{ color: "#2196f3", cursor: "pointer" }}
              onClick={() => window.location.reload()}
              title="Actualizar"
            >
              refresh
            </Icon>
          </SuiBox>
        </SuiBox>

        {rows.length > 0 ? (
          <div
            className="compact-table"
            style={{
              width: "100%",
              overflowX: "auto",
              padding: "0 8px 8px 8px",
            }}
          >
            <div style={{ minWidth: "900px" }}>
              <Table key="tbl_Operador_mejorado" columns={columns} rows={rows} />
            </div>
          </div>
        ) : (
          <SuiBox p={3} textAlign="center">
            <Icon style={{ fontSize: "48px", color: "#9e9e9e", marginBottom: "16px" }}>
              assignment_turned_in
            </Icon>
            <SuiTypography variant="body2" textColor="text">
              No tienes procesos asignados actualmente
            </SuiTypography>
          </SuiBox>
        )}
      </Card>
    </div>
  );
}

export default CardOperador;
